export const PRODUCTION = !(
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
);

// export const SERVER_URL = " https://openleague-app.herokuapp.com/";
// export const SERVER_URL = "https://openleaguescores.uc.r.appspot.com";
export const SERVER_URL = "https://openleaguescores.uc.r.appspot.com";
// export const SERVER_URL = "https://open-league-app.herokuapp.com";
// export const SERVER_URL = "https://encoded-obelisk-310514.uc.r.appspot.com/";
//export const SERVER_URL = "http://localhost:8080";
